import React from 'react'
import { Modal } from 'react-bootstrap'
import styled from 'styled-components'
import { COLORS } from '../../styles/theme'
import whatsapp from '../../images/booth/whatsapp.png'

const StyledModal = styled(Modal)`
  .modal-content {
    border: 2px solid ${COLORS.primaryLight};
    box-shadow: 0px 4px 12px ${COLORS.lightGray1} ;
  }
  .modal-body {
    padding: 16px 32px;
    .content {
      width: 100%;
      overflow-x: scroll;
      padding-bottom: 16px;
    }
    .divider {
      background: linear-gradient(270deg, #FE1E9A, #254DDE);
      width: 100%;
      height: 4.5px;
      margin: 16px auto;
    }
    .contact {
      width: 100%;
      margin: 16px 0;
      h5 {
        text-decoration: underline;
      }
    }
  }
`

export default function InfoModal({ title, description, content, infoOpen, setInfoOpen, agents }) {
  return (
    <StyledModal
      show={infoOpen}
      onHide={()=>setInfoOpen(false)}
      size="lg"
      aria-labelledby="info-modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="info-modal" className="px-3">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div
          className="content"
          dangerouslySetInnerHTML={{ __html: content }}
        />
        <div className="contact">
          <div >
            <h5 className="p-0 font-weight-bold">
              Contact Informations
              <img src={whatsapp} width="24px" className="ml-3" alt="whatsapp logo" />
            </h5>
          </div>
          {
            agents.map((agent,index)=>(
                <div key={`Agent-${index+1}`} >
                  <p className="my-0 font-weight-bold">{agent.name}</p>
                  <p className="mb-0">{agent.phone}</p>
                  <p>{agent.email}</p>
                </div>
            ))
          }
        </div>
      </Modal.Body>
    </StyledModal>
  )
}
